import { useConversationStore } from '@/hooks/useConversationStore';

/**
 * Custom hook for handling common bubble actions
 * Centralizes the logic for reset chat, privacy policy, and terms of service
 */
export const useBubbleActions = (config = {}, interfaceType = 'bubble') => {
  const { resetCurrentConversation, reset } = useConversationStore(config?.kb_id, interfaceType);

  /**
   * Reset chat functionality
   * Clears conversation state (current + history) without reloading the page.
   * Optional callback runs after the store resets for additional UI cleanup.
   */
  const resetChat = (onAfterReset = null) => {
    resetCurrentConversation();
    reset();

    if (onAfterReset && typeof onAfterReset === 'function') {
      onAfterReset();
    }
  };

  /**
   * Open privacy policy link
   * Uses custom link from config or falls back to default Dante AI privacy policy
   */
  const openPrivacyPolicy = () => {
    const url = config?.privacy_policy_link || 'https://www.dante-ai.com/privacy-policy';
    window.open(url, '_blank');
  };

  /**
   * Open terms of service link
   * Uses custom link from config or falls back to default Dante AI terms of service
   */
  const openTermsOfService = () => {
    const url = config?.terms_of_use_link || 'https://www.dante-ai.com/terms-of-service';
    window.open(url, '_blank');
  };

  /**
   * Generic function to open any external link
   * Can be used for other bubble actions that need to open links
   */
  const openExternalLink = (url, fallbackUrl = null) => {
    const targetUrl = url || fallbackUrl;
    if (targetUrl) {
      window.open(targetUrl, '_blank');
    } else {
      console.warn('No URL provided for external link');
    }
  };

  return {
    resetChat,
    openPrivacyPolicy,
    openTermsOfService,
    openExternalLink,
  };
};

export default useBubbleActions;
